import Model, { attr } from '@ember-data/model';

export default class SmartInsightDayKpisModel extends Model {
  @attr('number') declare adr: number;
  @attr('number') declare adrPickupVsYesterday: number;
  @attr('number') declare adrStly: number;
  @attr('number') declare demand: number;
  @attr('number') declare lowestRate: number | null;
  @attr('number') declare medianCompsetRate: number | null;
  @attr('number') declare occupancy: number;
  @attr('number') declare occupancyPickupVs3DaysAgo: number;
  @attr('number') declare occupancyPickupVs7DaysAgo: number;
  @attr('number') declare occupancyPickupVsYesterday: number;
  @attr('number') declare occupancyStly: number;
  @attr('number') declare occupancyStlyPickupVs3DaysAgo: number;
  @attr('number') declare occupancyStlyPickupVs7DaysAgo: number;
  @attr('number') declare occupancyStlyPickupVsYesterday: number;
  @attr('number') declare ownRate: number | null;
  @attr('number') declare roomNights: number;
  @attr('number') declare roomNightsPickupVs3DaysAgo: number;
  @attr('number') declare roomNightsPickupVs7DaysAgo: number;
  @attr('number') declare roomNightsPickupVsYesterday: number;
  @attr('number') declare roomNightsStly: number;
  @attr('number') declare roomNightsStlyPickupVs3DaysAgo: number;
  @attr('number') declare roomNightsStlyPickupVs7DaysAgo: number;
  @attr('number') declare roomNightsStlyPickupVsYesterday: number;
}
